import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext({ ids: [], toggle: () => {}, isSaved: () => false, enabled: false, refresh: () => {} });

export const FavoritesProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);
  const isCustomer = !!user && user.role === "customer";

  const refresh = useCallback(() => {
    if (!isCustomer) { setIds([]); return; }
    api.get("/my/favorites/ids").then((r) => setIds(r.data)).catch(() => {});
  }, [isCustomer]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = useCallback(async (carId) => {
    const saved = ids.includes(carId);
    setIds((p) => (saved ? p.filter((x) => x !== carId) : [...p, carId]));
    try {
      if (saved) await api.delete(`/my/favorites/${carId}`);
      else await api.post(`/my/favorites/${carId}`);
    } catch {
      refresh();
    }
  }, [ids, refresh]);

  return (
    <FavoritesContext.Provider value={{ ids, toggle, isSaved: (id) => ids.includes(id), enabled: isCustomer, refresh }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
